{
  "v1.acces.chargement": "Vérification de votre situation…",
  "v1.acces.choisie.depuis": "Depuis",
  "v1.acces.choisie.extension": "Extension : {{droit}}",
  "v1.acces.choisie.motif": "Motif",
  "v1.acces.choisie.origine": "Origine enregistrée",
  "v1.acces.choisie.origine_absente": "Aucune origine enregistrée",
  "v1.acces.choisie.portee": "Portée",
  "v1.acces.choisie.reponse": "Réponse",
  "v1.acces.choisie.sans_message": "Sans message",
  "v1.acces.choisie.statut": "Statut",
  "v1.acces.choisie.titre": "Sollicitation choisie",
  "v1.acces.contexte.cible": "Vous vouliez ouvrir : {{ecran}} {{objet}}",
  "v1.acces.contexte.projet": "Projet demandé : {{projet}}",
  "v1.acces.contexte.protege": "Le contenu du projet n’est pas montré tant que vous ne pouvez pas le lire.",
  "v1.acces.contexte.titre": "Votre situation",
  "v1.acces.disponibilite.chargement": "Vérification du projet…",
  "v1.acces.disponibilite.existe": "Ce projet existe dans votre organisation ; son contenu reste protégé.",
  "v1.acces.disponibilite.indisponible": "Ce projet est indisponible : il n’existe pas, ou vous ne pouvez pas savoir s’il existe.",
  "v1.acces.disponibilite.membre": "Vous êtes membre de ce projet.",
  "v1.acces.disponibilite.titre": "Disponibilité du projet",
  "v1.acces.habilitee.chargement": "Recherche des personnes habilitées…",
  "v1.acces.habilitee.non_divulguable": "Les personnes habilitées ne peuvent pas vous être indiquées.",
  "v1.acces.habilitee.profils": "Peuvent vous l’accorder : {{profils}}.",
  "v1.acces.motif.acces_retire": "Votre accès à ce projet a été retiré.",
  "v1.acces.motif.admission_initiale": "Vous n’êtes pas encore membre de ce projet.",
  "v1.acces.motif.droit_absent": "Il vous manque le droit « {{droit}} » dans ce projet.",
  "v1.acces.motif.droit_tenu": "Vous tenez maintenant le droit « {{droit}} » : vous pouvez revenir à l’objet.",
  "v1.acces.motif.membre": "Vous êtes membre de ce projet ; aucun motif d’admission ne s’applique.",
  "v1.acces.motif.non_divulguable": "Le motif ne peut pas vous être précisé.",
  "v1.acces.motif.politique_bloquante": "Une politique de l’organisation bloque cette action.",
  "v1.acces.motif.separation_des_taches": "La séparation des tâches vous empêche de faire cette action.",
  "v1.acces.motif.signale": "(motif signalé à votre arrivée)",
  "v1.acces.origine.projet-apercu-fiche": "l’aperçu",
  "v1.acces.origine.projet-cible-application-lecteur": "la cible d’application",
  "v1.acces.origine.projet-document-fiche": "le document",
  "v1.acces.origine.projet-element-fiche": "l’élément",
  "v1.acces.origine.projet-service-environnement": "le service",
  "v1.acces.origine.projet-version-fiche": "la version",
  "v1.acces.origine.projet-vue": "la vue du projet",
  "v1.acces.reevaluer": "Réévaluer mes droits",
  "v1.acces.reevaluer.echec": "La réévaluation a échoué.",
  "v1.acces.reevaluer.fait": "Droits réévalués.",
  "v1.acces.retour.lien-retour-apercu": "Revenir à l’aperçu",
  "v1.acces.retour.lien-retour-cible-application": "Revenir à la cible d’application",
  "v1.acces.retour.lien-retour-document": "Revenir au document",
  "v1.acces.retour.lien-retour-element": "Revenir à l’élément",
  "v1.acces.retour.lien-retour-service": "Revenir au service",
  "v1.acces.retour.lien-retour-version": "Revenir à la version",
  "v1.acces.retour.lien-retour-vue": "Revenir à la vue du projet",
  "v1.acces.sans_projet": "Aucun projet n’est indiqué.",
  "v1.acces.separation.requise": "Une autre personne doit intervenir : la séparation des tâches ne se contourne pas.",
  "v1.acces.separation.sans_objet": "La séparation des tâches n’est pas en cause.",
  "v1.acces.solliciter.acces": "Solliciter l’accès",
  "v1.acces.solliciter.deja_en_attente": "Une sollicitation est déjà en attente pour ce projet.",
  "v1.acces.solliciter.deja_membre": "Vous êtes déjà membre : sollicitez plutôt le droit qui vous manque.",
  "v1.acces.solliciter.droit": "Solliciter ce droit",
  "v1.acces.solliciter.droit_en_attente": "Ce droit est déjà sollicité.",
  "v1.acces.solliciter.droit_inconnu": "Le droit manquant n’est pas connu de cet écran : réévaluez vos droits.",
  "v1.acces.solliciter.fait": "Sollicitation envoyée.",
  "v1.acces.solliciter.impossible": "Aucune sollicitation possible : le projet est indisponible.",
  "v1.acces.solliciter.message": "Message pour la personne habilitée (facultatif)",
  "v1.acces.solliciter.titre": "Solliciter",
  "v1.acces.suite.titre": "Ma suite dans ce projet",
  "v1.acces.suite.tout": "Tout mon suivi personnel",
  "v1.acces.suite.vide": "Aucune sollicitation pour ce projet.",
  "v1.acces.titre": "Comprendre un refus d’accès",
  "v1.accueil.attention.titre": "Ce qui m’attend",
  "v1.accueil.attention.total": "{{n}} éléments au total",
  "v1.accueil.attention.total_one": "{{n}} élément au total",
  "v1.accueil.attention.tout": "Toute l’attention",
  "v1.accueil.attention.vide": "Rien ne vous attend.",
  "v1.accueil.code.CONTEXTE_INCOMPLET": "Ce projet n’est pas parmi les vôtres.",
  "v1.accueil.code.DROIT_NON_TENU": "Vous ne tenez pas le droit requis.",
  "v1.accueil.code.ELEMENT_INTROUVABLE": "Cet élément n’est plus dans votre boîte.",
  "v1.accueil.code.FAVORI_HORS_DE_MES_ESPACES": "Cet espace n’est pas parmi les vôtres.",
  "v1.accueil.code.INVITATION_EMAIL_UNVERIFIED": "Votre adresse n’est pas attestée : ouvrez le lien reçu par courriel.",
  "v1.accueil.code.INVITATION_EXPIREE": "Cette invitation a expiré.",
  "v1.accueil.code.INVITATION_INTROUVABLE": "Cette invitation n’est plus disponible.",
  "v1.accueil.code.NOTIFICATION_INTROUVABLE": "Cette notification n’est plus disponible.",
  "v1.accueil.code.RECHERCHE_TROP_COURTE": "Saisissez au moins 3 caractères.",
  "v1.accueil.code.REPORT_DATE_PASSEE": "La date de report doit être dans le futur.",
  "v1.accueil.code.RESOURCE_UNAVAILABLE": "Ressource indisponible.",
  "v1.accueil.code.SANS_SESSION": "Votre session a pris fin : reconnectez-vous.",
  "v1.accueil.code.SEARCH_PERIOD_INVALID": "Choisissez une période proposée.",
  "v1.accueil.code.SEARCH_TYPE_UNKNOWN": "Ce type d’objet n’est pas cherché.",
  "v1.accueil.detail.indisponible": "Ce détail n’est plus disponible : la relecture a été refusée ou a échoué.",
  "v1.accueil.espaces.aucun_favori": "Aucun favori.",
  "v1.accueil.espaces.aucun_programme": "Aucun programme.",
  "v1.accueil.espaces.aucun_recent": "Aucun espace récent.",
  "v1.accueil.espaces.favori": "Favori",
  "v1.accueil.espaces.favoris": "Favoris",
  "v1.accueil.espaces.programmes": "Programmes",
  "v1.accueil.espaces.projets": "Projets",
  "v1.accueil.espaces.recents": "Récents",
  "v1.accueil.espaces.retirer": "Retirer {{nom}} des favoris",
  "v1.accueil.espaces.retirer_court": "Retirer",
  "v1.accueil.espaces.retirer_echec": "Le favori n’a pas pu être retiré.",
  "v1.accueil.espaces.sante.non_publiee": "Santé non publiée",
  "v1.accueil.espaces.titre": "Mes espaces",
  "v1.accueil.espaces.variante_membre": "Vue membre : ni annuaire ni administration.",
  "v1.accueil.espaces.vide": "Aucun espace ne vous est encore accessible.",
  "v1.accueil.etat.chargement": "Chargement : {{quoi}}…",
  "v1.accueil.etat.erreur": "Lecture impossible : {{quoi}}.",
  "v1.accueil.etat.reessayer": "Réessayer",
  "v1.accueil.etat.refus": "Accès refusé : {{quoi}}.",
  "v1.accueil.lien_mes_demandes": "Mes demandes et invitations",
  "v1.accueil.lien_mes_demandes.compteur": "Mes demandes et invitations ({{n}} en attente)",
  "v1.accueil.lien_traitements": "Traitements en cours",
  "v1.accueil.lien_vue_d_ensemble": "Vue d’ensemble de l’organisation",
  "v1.accueil.nature.access_request_to_decide": "Demande d’accès à décider",
  "v1.accueil.nature.ai_tool_execution": "Outil IA à autoriser",
  "v1.accueil.nature.approval": "Approbation",
  "v1.accueil.nature.campaign_to_run": "Campagne à exécuter",
  "v1.accueil.nature.defect_to_verify": "Anomalie à vérifier",
  "v1.accueil.nature.mission_escalation": "Escalade de mission",
  "v1.accueil.nature.mission_plan": "Plan de mission",
  "v1.accueil.nature.mission_task_stopped": "Tâche de mission arrêtée",
  "v1.accueil.nature.recette_to_run": "Recette à exécuter",
  "v1.accueil.nature.regression_to_accept": "Régression à accepter",
  "v1.accueil.nature.waiver_expired": "Dérogation expirée",
  "v1.accueil.nature.waiver_to_decide": "Dérogation à décider",
  "v1.accueil.obstacles.bloque": "{{titre}} : bloqué par {{n}} élément(s)",
  "v1.accueil.obstacles.sans_tache": "Choisissez une tâche pour voir les obstacles de la cadence de son projet.",
  "v1.accueil.obstacles.stagnant": "{{titre}} : inchangé depuis {{n}} jour(s)",
  "v1.accueil.obstacles.titre": "Obstacles de la cadence",
  "v1.accueil.obstacles.vide": "Aucun obstacle dans la cadence.",
  "v1.accueil.premiers_pas.lien": "Voir mes invitations et sollicitations",
  "v1.accueil.premiers_pas.texte": "Aucun projet ne vous est encore ouvert : rejoignez une invitation reçue ou sollicitez l’accès à un projet.",
  "v1.accueil.premiers_pas.titre": "Premiers pas",
  "v1.accueil.raccourcis": "Raccourcis de l’accueil",
  "v1.accueil.refus_avant.ACCESS_DENIED": "Bloqué : il vous manque le droit de trancher.",
  "v1.accueil.refus_avant.SELF_APPROVAL_REFUSED": "Vous êtes l’auteur : une autre personne doit trancher.",
  "v1.accueil.refus_avant.autre": "Bloqué ({{code}}).",
  "v1.accueil.sans_organisation": "Aucune organisation n’est associée à votre session.",
  "v1.accueil.tache.choisir": "Choisir : {{titre}}",
  "v1.accueil.tache.disparue": "Cette tâche n’est plus dans votre travail.",
  "v1.accueil.tache.nature": "Nature",
  "v1.accueil.tache.nature.anomalie": "Anomalie",
  "v1.accueil.tache.nature.campagne": "Campagne à exécuter",
  "v1.accueil.tache.nature.element": "Élément de travail",
  "v1.accueil.tache.ouvrir": "Ouvrir dans son projet",
  "v1.accueil.tache.projet": "Projet",
  "v1.accueil.tache.titre": "Tâche choisie",
  "v1.accueil.tache.titre_champ": "Titre",
  "v1.accueil.tache.vide": "Choisissez une tâche pour la voir ici.",
  "v1.accueil.tache.voir": "Choisir",
  "v1.accueil.titre": "Mon accueil",
  "v1.accueil.travail.cadence": "Cadence en cours : {{nom}}",
  "v1.accueil.travail.cadence.active": "Cadence en cours",
  "v1.accueil.travail.cadence.modele_sans_iteration": "Le modèle de ce projet ne prévoit pas d’itération.",
  "v1.accueil.travail.cadence.sans_cadence_active": "Aucune cadence n’est en cours dans ce projet.",
  "v1.accueil.travail.revue": "{{quoi}} — demandée par {{qui}}",
  "v1.accueil.travail.revues": "Revues demandées ({{n}})",
  "v1.accueil.travail.rien_dans_le_projet": "Rien ne vous est assigné dans ce projet.",
  "v1.accueil.travail.titre": "Mon travail",
  "v1.accueil.travail.vide": "Rien ne vous est assigné.",
  "v1.attention.affiches": "{{n}} affichés sur {{total}}",
  "v1.attention.autres.titre": "En attente des autres",
  "v1.attention.autres.vide": "Personne ne vous doit de réponse.",
  "v1.attention.choisi.actionnable": "À votre main",
  "v1.attention.choisi.bloque": "Bloqué, motif ci-dessus",
  "v1.attention.choisi.depuis": "Depuis",
  "v1.attention.choisi.disparu": "Cet élément n’est plus dans votre boîte.",
  "v1.attention.choisi.etat": "État",
  "v1.attention.choisi.titre": "Élément choisi",
  "v1.attention.choisi.vide": "Choisissez un élément pour le voir ici.",
  "v1.attention.delais.titre": "Délais de décision",
  "v1.attention.delais.valeurs": "Délai médian {{p50}}, 95 % sous {{p95}} ({{n}} décisions sur {{jours}} jours)",
  "v1.attention.delais.vide": "Aucune décision mesurée sur la période.",
  "v1.attention.filtre_vide": "Aucun élément de cette nature.",
  "v1.attention.hitl.ligne": "{{quoi}} — en attente depuis {{heures}}",
  "v1.attention.hitl.titre": "Décisions humaines en attente",
  "v1.attention.hitl.vide": "Aucune décision humaine en attente.",
  "v1.attention.liste.titre": "À traiter",
  "v1.attention.nature": "Nature",
  "v1.attention.nature.toutes": "Toutes les natures",
  "v1.attention.ouvrir": "Ouvrir : {{titre}}",
  "v1.attention.partiel": "Certaines sources n’ont pas pu être lues : la liste est partielle.",
  "v1.attention.portee": "Portée",
  "v1.attention.portee.tous": "Tous mes projets",
  "v1.attention.reporte_jusqu_au": "Reporté jusqu’au {{date}}",
  "v1.attention.reporter": "Reporter",
  "v1.attention.reporter_echec": "Le report a échoué.",
  "v1.attention.reporter_jusqu_au": "Reporter jusqu’au",
  "v1.attention.reportes": "Reportés ({{n}})",
  "v1.attention.sans_ecran": "Écran de cet objet à venir.",
  "v1.attention.suite": "Afficher la suite",
  "v1.attention.titre": "Boîte d’attention",
  "v1.demandes.a_decider": "Demandes à décider",
  "v1.demandes.a_decider.ligne": "{{qui}} demande l’accès à {{nom}} ({{date}})",
  "v1.demandes.a_decider.vide": "Aucune demande ne vous attend.",
  "v1.demandes.annuler": "Annuler ma sollicitation",
  "v1.demandes.annuler.consequence": "La personne habilitée ne la verra plus.",
  "v1.demandes.annuler.fait": "Sollicitation annulée.",
  "v1.demandes.annuler.plus_en_attente": "Cette sollicitation n’est plus en attente.",
  "v1.demandes.annuler.reversibilite": "Vous pourrez solliciter de nouveau.",
  "v1.demandes.annuler.titre": "Annuler votre sollicitation pour {{nom}} ?",
  "v1.demandes.annuler.verbe": "Annuler la sollicitation",
  "v1.demandes.choisir": "Choisissez une sollicitation.",
  "v1.demandes.decider": "Décider dans {{nom}}",
  "v1.demandes.echec": "L’action a échoué.",
  "v1.demandes.invitation.acceptee": "Vous avez rejoint {{nom}}.",
  "v1.demandes.invitation.accepter": "Accepter",
  "v1.demandes.invitation.accepter.nom": "Accepter l’invitation à {{nom}}",
  "v1.demandes.invitation.expire_le": "expire le {{date}}",
  "v1.demandes.invitation.expiree_le": "expirée le {{date}}",
  "v1.demandes.invitation.ignorer": "Ignorer",
  "v1.demandes.invitation.ignorer.nom": "Ignorer l’invitation à {{nom}}",
  "v1.demandes.invitation.ouvrir": "Ouvrir le projet",
  "v1.demandes.invitation.profil": "Profil proposé : {{role}}",
  "v1.demandes.invitations": "Invitations reçues",
  "v1.demandes.invitations.vide": "Aucune invitation en attente.",
  "v1.demandes.lien.accepter": "Accepter par le lien",
  "v1.demandes.lien.champ": "Lien ou code d’invitation",
  "v1.demandes.lien.fait": "Invitation acceptée.",
  "v1.demandes.lien.manquant": "Collez le lien ou le code reçu.",
  "v1.demandes.nature.admission": "Admission",
  "v1.demandes.nature.extension": "Extension de droit",
  "v1.demandes.role.contributor": "Contributeur",
  "v1.demandes.role.owner": "Propriétaire",
  "v1.demandes.role.viewer": "Lecteur",
  "v1.demandes.situation": "Ma situation dans {{nom}}",
  "v1.demandes.situation.aucune": "Choisissez une sollicitation pour voir votre situation dans son projet.",
  "v1.demandes.sollicitations": "Mes sollicitations",
  "v1.demandes.sollicitations.vide": "Vous n’avez sollicité aucun accès.",
  "v1.demandes.statut.approved": "Acceptée",
  "v1.demandes.statut.cancelled": "Annulée",
  "v1.demandes.statut.pending": "En attente",
  "v1.demandes.statut.rejected": "Refusée",
  "v1.demandes.titre": "Mes demandes et invitations",
  "v1.notifications.choisie.cible": "Objet",
  "v1.notifications.choisie.disparue": "Cette notification n’est plus dans la liste.",
  "v1.notifications.choisie.etat": "Lecture",
  "v1.notifications.choisie.rangement": "Rangement",
  "v1.notifications.choisie.recue": "Reçue",
  "v1.notifications.choisie.titre": "Notification choisie",
  "v1.notifications.choisie.vide": "Choisissez une notification pour la voir ici.",
  "v1.notifications.echec": "L’action a échoué.",
  "v1.notifications.enregistrer": "Enregistrer",
  "v1.notifications.liste": "Mes notifications",
  "v1.notifications.lue": "Lue",
  "v1.notifications.marquer_lue": "Marquer lue",
  "v1.notifications.marquer_lue.nom": "Marquer lue : {{titre}}",
  "v1.notifications.non_lue": "Non lue",
  "v1.notifications.non_lues": "Non lues seulement",
  "v1.notifications.projet": "Projet",
  "v1.notifications.range.enregistrer": "Notification enregistrée.",
  "v1.notifications.range.reporter": "Notification reportée.",
  "v1.notifications.range.terminer": "Notification terminée.",
  "v1.notifications.rangement": "Rangement",
  "v1.notifications.rangement.a_traiter": "À traiter",
  "v1.notifications.rangement.enregistrees": "Enregistrées",
  "v1.notifications.rangement.etat.a_traiter": "À traiter",
  "v1.notifications.rangement.etat.enregistree": "Enregistrée",
  "v1.notifications.rangement.etat.reportee": "Reportée",
  "v1.notifications.rangement.etat.terminee": "Terminée",
  "v1.notifications.rangement.reportees": "Reportées",
  "v1.notifications.rangement.terminees": "Terminées",
  "v1.notifications.rangement.toutes": "Toutes",
  "v1.notifications.regler": "Régler mes notifications",
  "v1.notifications.terminer": "Terminer",
  "v1.notifications.titre": "Notifications",
  "v1.notifications.tout_lu.fait": "{{n}} notification(s) marquée(s) lue(s).",
  "v1.notifications.tout_lu.projet": "Tout marquer lu ({{nom}})",
  "v1.notifications.tout_lu.tous": "Tout marquer lu (tous mes projets)",
  "v1.notifications.vide": "Aucune notification.",
  "v1.recherche.apercu.court": "Aperçu",
  "v1.recherche.apercu.disparu": "Ce résultat n’est plus dans la liste.",
  "v1.recherche.apercu.nom": "Aperçu : {{titre}}",
  "v1.recherche.apercu.titre": "Aperçu du résultat",
  "v1.recherche.apercu.vide": "Choisissez un résultat pour l’aperçu.",
  "v1.recherche.aucun": "Aucun résultat pour « {{q}} ».",
  "v1.recherche.auteur": "Auteur",
  "v1.recherche.champ": "Rechercher",
  "v1.recherche.extrait": "Extrait",
  "v1.recherche.invite": "Saisissez au moins 3 caractères puis lancez la recherche.",
  "v1.recherche.lancer": "Lancer la recherche",
  "v1.recherche.partiel": "Certains types n’ont pas pu être lus : les résultats sont partiels.",
  "v1.recherche.periode": "Période",
  "v1.recherche.periode.30j": "30 derniers jours",
  "v1.recherche.periode.365j": "12 derniers mois",
  "v1.recherche.periode.7j": "7 derniers jours",
  "v1.recherche.periode.90j": "90 derniers jours",
  "v1.recherche.periode.toute": "Toute période",
  "v1.recherche.reference": "Référence",
  "v1.recherche.resultats": "Résultats",
  "v1.recherche.statut": "Statut",
  "v1.recherche.titre": "Recherche",
  "v1.recherche.tous_mes_espaces": "Tous mes espaces",
  "v1.recherche.tronque": "D’autres résultats existent : affinez la recherche.",
  "v1.recherche.type": "Type",
  "v1.recherche.type.adr": "Décisions d’architecture",
  "v1.recherche.type.defect": "Anomalies",
  "v1.recherche.type.deployment": "Déploiements",
  "v1.recherche.type.document": "Documents",
  "v1.recherche.type.item": "Éléments",
  "v1.recherche.type.mission": "Missions",
  "v1.recherche.type.program": "Programmes",
  "v1.recherche.type.project": "Projets",
  "v1.recherche.type.release": "Versions",
  "v1.recherche.type.requirement": "Exigences",
  "v1.recherche.type.sprint": "Cadences",
  "v1.recherche.type.test_campaign": "Campagnes",
  "v1.recherche.type.test_case": "Cas de test",
  "v1.recherche.type.tous": "Tous les types"
}
